<template>
  <div id="PageNotFound">
    Страница не найдена
  </div>
</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>

<style scoped>

</style>